import React, { useEffect } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from "react-redux";

import IconWithTextCard from './IconWithTextCard';
import { fetchTransactionSummary } from '../../redux/actions/Transactions';
import { dateAndTimeRangeQueriesArray } from '../../util/lib';
import { fetchMerchantAccounts } from '../../redux/actions/Data';
import { TransactionStatuses, TransactionTypes } from '../../constants/System';

const FailedCard = ({ merchantId }) => {
  const dispatch = useDispatch();
  const { timezone } = useSelector(({ settings }) => settings);
  const { data: merchantAccounts, loading: loadingMerchants } = useSelector(({ data }) => data.merchantAccounts);
  const { data: transactionSummary } = useSelector(({ transactions }) => transactions.transactionSummaryFailed);

  const todaysDate = moment().format('YYYY-MM-DD');

  useEffect(() => {
    if (!merchantId) {
      dispatch(fetchMerchantAccounts());
    } else {
      const queries = [
        `merchant_id={"$in": ["${merchantId}"]}`,
        `transaction_type=${transactionType}`,
        `transaction_status=${transactionStatus}`,
        ...dateAndTimeRangeQueriesArray(todaysDate, todaysDate, timezone),
      ];
      const params = queries.join('&');
      dispatch(fetchTransactionSummary(params, transactionType, transactionStatus));
    }
  }, [dispatch, merchantId, timezone]);


  const transactionType = TransactionTypes.COLLECTION;
  const transactionStatus = TransactionStatuses.FAILED;

  useEffect(() => {
    if (!merchantId && merchantAccounts && merchantAccounts.length > 0) {
      const queries = [
        `merchant_id={"$in": [${merchantAccounts.map((account) => `"${account._id}"`).join(',')}]}`,
        `transaction_type=${transactionType}`,
        `transaction_status=${transactionStatus}`,
        ...dateAndTimeRangeQueriesArray(todaysDate, todaysDate, timezone),
      ];
      const params = queries.join('&');
      dispatch(fetchTransactionSummary(params, transactionType, transactionStatus));
    }

  }, [merchantAccounts, merchantId]);


  return (
    <IconWithTextCard icon="chart-pie" iconColor="primary" title={transactionSummary.total_count} subTitle="Failed" />
  )
};

export default FailedCard;
